import { defineMessage } from 'services/localization';

export const messages = {
    contactFieldPlaceholder: defineMessage('choose_supplier'),
};
